var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 583,
    viewBox: "0 0 631 583",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8292_16214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.201 79.7205C506.201 79.7205 437.75 29.1522 350.256 57.0045C262.761 84.8569 227.16 160.085 177.602 213C151.63 240.764 112.81 252.261 81.7905 274.094C-17.4153 343.92 -0.176378 489.896 78.0045 541.638C145.723 586.477 229.445 587.663 337.699 547.355C445.953 507.046 523.554 482.324 589.354 378.057C655.155 273.791 590.616 148.752 506.201 79.7205Z",
    fill: "#0E1868"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M506.201 79.7205C506.201 79.7205 437.75 29.1522 350.256 57.0045C262.761 84.8569 227.16 160.085 177.602 213C151.63 240.764 112.81 252.261 81.7905 274.094C-17.4153 343.92 -0.176378 489.896 78.0045 541.638C145.723 586.477 229.445 587.663 337.699 547.355C445.953 507.046 523.554 482.324 589.354 378.057C655.155 273.791 590.616 148.752 506.201 79.7205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.089 7.91025H133V337.81H555.089V7.91025Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.056 -5H146.692V325.682H570.056V-5Z",
    fill: "#F47833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.056 -5H146.692V325.682H570.056V-5Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.817 41.8581H158.215V98.6481H247.817V41.8581Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.824 66.4797H220.684",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.358 75.9447H235.827",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.817 109.375H158.215V166.165H247.817V109.375Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 122.853H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 130.375H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 137.896H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 145.418H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 152.939H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 122.853H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 130.375H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 137.896H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 145.418H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 152.939H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.817 176.892H158.215V233.682H247.817V176.892Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 190.37H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 197.892H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 205.413H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 212.935H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 220.456H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 190.37H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 197.892H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 205.413H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 212.935H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 220.456H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.817 244.409H158.215V301.199H247.817V244.409Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 257.887H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 265.409H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 272.93H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 280.452H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 287.973H198.965",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 257.887H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 265.409H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 272.93H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 280.452H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.448 287.973H237.872",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.043 -5H260.437V325.682H570.043V-5Z",
    fill: "#B8B8B8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.435 57.6457H269.271V248.208H549.435V57.6457Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.364 133.29H488.126",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.466 149.999H509.025",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.043 -5H559.102V325.682H570.043V-5Z",
    fill: "#DBDBDB",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.043 97.4492H559.102V186.799H570.043V97.4492Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.056 -5H146.692V16.4792H570.056V-5Z",
    fill: "#F47833",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.72 -1.34021H174.532V10.775H446.72V-1.34021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.422 24.0765H528.41",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.422 30.5505H528.41",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.422 37.012H528.41",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.922 515.451L549.033 500.837",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.288 475.989V530.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.908 504.232C535.908 504.232 528.336 495.966 520.764 497.342C513.192 498.717 509.734 507.69 509.734 513.205C509.734 518.72 517.306 536.64 517.306 536.64C517.306 536.64 522.821 530.444 535.239 521.496C547.657 512.549 548.326 503.538 535.908 504.232Z",
    fill: "#FFCC33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.909 504.232C529.409 507.914 524.141 513.432 520.765 520.095",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.276 494.527C548.276 494.527 554.586 487.725 560.783 488.874C566.979 490.022 569.856 497.417 569.844 501.96C569.831 506.504 563.534 521.269 563.534 521.269C559.046 516.617 554.113 512.416 548.806 508.725C538.597 501.317 538.041 493.934 548.276 494.527Z",
    fill: "#FFCC33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.275 494.527C553.632 497.566 557.966 502.125 560.731 507.627",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.19 485.491L552.693 471.597",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.6 481.466C541.6 481.466 541.449 472.228 536.009 468.934C530.57 465.64 523.566 469.275 520.55 472.72C517.534 476.165 512.372 491.284 512.372 491.284C512.372 491.284 519.162 490.464 531.719 491.726C544.275 492.988 549.626 487.826 541.6 481.466Z",
    fill: "#FFCC33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.599 481.466C535.577 480.175 529.307 480.693 523.578 482.955",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.765 469.073C549.765 469.073 549.879 462.271 553.88 459.848C557.88 457.425 563.054 460.1 565.238 462.599C567.421 465.097 571.232 476.291 571.232 476.291C566.488 475.936 561.72 476.046 556.997 476.62C547.784 477.541 543.922 473.755 549.765 469.073Z",
    fill: "#FFCC33",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.765 469.073C554.197 468.122 558.812 468.504 563.028 470.171",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.508 525.762H518.53L523.49 576.747H562.549L567.508 525.762Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.522 547.973C554.522 548.407 554.651 548.832 554.893 549.193C555.134 549.554 555.477 549.836 555.878 550.002C556.279 550.168 556.721 550.211 557.147 550.127C557.573 550.042 557.964 549.833 558.271 549.526C558.578 549.219 558.787 548.827 558.872 548.401C558.957 547.975 558.913 547.534 558.747 547.133C558.581 546.731 558.299 546.388 557.938 546.147C557.577 545.906 557.153 545.777 556.718 545.777C556.43 545.775 556.143 545.831 555.876 545.941C555.609 546.051 555.366 546.212 555.162 546.417C554.958 546.621 554.796 546.864 554.686 547.131C554.576 547.398 554.521 547.684 554.522 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.446 547.973C546.446 548.407 546.575 548.832 546.816 549.193C547.058 549.554 547.401 549.836 547.802 550.002C548.203 550.168 548.645 550.211 549.071 550.127C549.497 550.042 549.888 549.833 550.195 549.526C550.502 549.219 550.711 548.827 550.796 548.401C550.881 547.975 550.837 547.534 550.671 547.133C550.505 546.731 550.223 546.388 549.862 546.147C549.501 545.906 549.076 545.777 548.642 545.777C548.353 545.775 548.067 545.831 547.8 545.941C547.533 546.051 547.29 546.212 547.086 546.417C546.882 546.621 546.72 546.864 546.61 547.131C546.5 547.398 546.445 547.684 546.446 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.159 542.483H565.881L566.096 540.3H519.944L520.159 542.483Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.925 562.587L564.846 553.084H521.193L522.115 562.587H563.925Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.562 547.973C562.562 548.261 562.618 548.546 562.729 548.811C562.839 549.077 563.001 549.318 563.205 549.521C563.41 549.724 563.652 549.885 563.918 549.994C564.184 550.103 564.47 550.158 564.757 550.156H565.136L565.54 545.966C565.29 545.87 565.025 545.819 564.757 545.815C564.182 545.815 563.629 546.041 563.218 546.445C562.807 546.848 562.571 547.397 562.562 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.445 547.973C538.445 548.407 538.574 548.832 538.815 549.193C539.057 549.554 539.4 549.836 539.801 550.002C540.202 550.168 540.644 550.211 541.07 550.127C541.496 550.042 541.887 549.833 542.194 549.526C542.501 549.219 542.71 548.827 542.795 548.401C542.88 547.975 542.836 547.534 542.67 547.133C542.504 546.731 542.222 546.388 541.861 546.147C541.5 545.906 541.076 545.777 540.641 545.777C540.352 545.775 540.066 545.831 539.799 545.941C539.532 546.051 539.289 546.212 539.085 546.417C538.881 546.621 538.719 546.864 538.609 547.131C538.499 547.398 538.444 547.684 538.445 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.367 547.973C522.367 548.407 522.496 548.832 522.737 549.193C522.979 549.554 523.322 549.836 523.723 550.002C524.124 550.168 524.566 550.211 524.991 550.127C525.417 550.042 525.809 549.833 526.116 549.526C526.423 549.219 526.632 548.827 526.717 548.401C526.802 547.975 526.758 547.534 526.592 547.133C526.426 546.731 526.144 546.388 525.783 546.147C525.422 545.906 524.997 545.777 524.563 545.777C524.274 545.775 523.988 545.831 523.721 545.941C523.454 546.051 523.211 546.212 523.007 546.417C522.802 546.621 522.641 546.864 522.531 547.131C522.421 547.398 522.366 547.684 522.367 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.406 547.973C530.406 548.407 530.535 548.832 530.776 549.193C531.018 549.554 531.361 549.836 531.762 550.002C532.163 550.168 532.605 550.211 533.031 550.127C533.456 550.042 533.848 549.833 534.155 549.526C534.462 549.219 534.671 548.827 534.756 548.401C534.841 547.975 534.797 547.534 534.631 547.133C534.465 546.731 534.183 546.388 533.822 546.147C533.461 545.906 533.036 545.777 532.602 545.777C532.313 545.775 532.027 545.831 531.76 545.941C531.493 546.051 531.25 546.212 531.046 546.417C530.841 546.621 530.68 546.864 530.57 547.131C530.46 547.398 530.405 547.684 530.406 547.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.833 576.873C215.89 569.402 226.706 556.227 230.429 552.769C234.009 549.34 237.381 545.698 240.525 541.865C240.525 541.865 234.126 554.27 245.03 564.051C255.934 573.831 288.291 566.31 295.434 561.047C302.577 555.785 303.334 542.244 296.949 522.304C290.563 502.364 281.514 465.514 281.893 452.717C282.272 439.921 273.993 403.815 270.232 394.034C266.471 384.254 251.05 377.111 235.25 373.729C219.449 370.347 176.945 388.015 176.945 388.015L168.3 391.397C168.3 391.397 132.964 410.958 123.537 418.858C114.11 426.758 118.641 448.578 116.394 469.641C114.148 490.703 114.135 515.161 114.135 515.161C114.135 515.161 92.3154 534.343 76.5152 556.151C68.9432 566.651 64.5388 573.049 62.04 576.873H209.833Z",
    fill: "#FFCC33",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.408 536.123C287.408 536.123 274.788 533.157 261.562 542.029C248.336 550.901 251.946 564.19 263.771 567.143C275.596 570.096 291.106 570.096 299.233 557.539C307.36 544.982 293.327 535.378 287.408 536.123Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.551 536.009C283.476 534.887 276.241 536.541 270.359 540.628C259.985 547.544 262.862 557.93 272.088 560.24C281.313 562.549 293.428 562.549 299.776 552.743C306.124 542.938 295.157 535.441 290.551 536.009Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.348 451.884C261.764 445.019 262.029 440.337 262.029 439.921",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.588 541.865C240.588 541.865 254.129 528.702 256.376 513.647C257.776 504.371 259.594 479.093 260.78 460.706",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.35 477.377C273.942 488.331 267.632 504.775 257.89 515.906",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.454 465.88C280.454 465.88 279.924 468.404 278.801 472.442",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.268 508.775C272.617 516.395 264.76 522.871 256.01 527.945",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.716 500.484C284.338 502.561 282.842 504.559 281.236 506.466",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.892 532.463C286.341 528.659 272.909 528.92 260.515 533.208C239.452 540.363 241.711 556.529 243.591 559.167",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.799 270.333C241.799 270.333 241.799 265.903 235.704 256.451C229.608 246.999 198.576 250.911 188.051 261.436C177.526 271.961 192.48 285.262 185.83 292.986C179.179 300.709 157.018 296.86 149.812 310.717C142.606 324.574 160.892 331.212 164.779 336.197C168.666 341.182 158.129 342.848 159.239 347.832C160.35 352.817 177.513 353.373 177.513 353.373C177.513 353.373 166.433 356.704 171.973 361.134C179.608 366.908 189.012 369.847 198.576 369.45C209.656 368.895 206.88 347.277 205.782 331.212C204.684 315.147 219.071 297.416 235.704 299.069C252.337 300.722 270.056 319.576 267.254 327.893C264.452 336.209 271.683 326.227 286.651 316.8C301.618 307.373 294.967 287.988 291.699 284.114C288.43 280.24 277.299 279.129 275.078 271.923C272.857 264.717 267.872 257.524 258.458 257.524C249.043 257.524 251.214 269.778 241.799 270.333Z",
    fill: "#181616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.348 369.955C194.348 369.955 187.205 371.836 184.252 375.609C181.299 379.382 169.108 386.172 168.363 391.397C167.619 396.621 172.149 423.754 181.147 434.658C190.145 445.562 194.689 446.319 194.689 446.319C194.689 446.319 197.326 435.794 199.207 435.037C201.087 434.279 218.389 445.133 218.389 445.133C218.389 445.133 221.393 427.465 223.286 427.465C225.179 427.465 231.173 433.484 231.173 433.484C231.173 433.484 233.432 418.429 231.93 406.768C230.428 395.107 220.648 380.821 213.505 375.925C206.362 371.028 200.658 366.573 194.348 369.955Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.021 355.669L184.139 388.911C184.139 388.911 187.71 404.395 192.405 414.352C198.803 427.894 214.616 434.343 214.616 434.343C214.514 426.489 216.22 418.716 219.601 411.627C222.759 405.222 226.466 399.104 230.681 393.34C230.681 393.34 205.782 368.971 198.021 355.669Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.604 368.277C201.604 368.277 207.978 404.711 217.089 416.094L225.734 399.688L203.018 364.163L201.604 368.277Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19 476.418C196.19 476.418 218.389 418.479 221.43 415.097C224.472 411.715 231.211 405.695 234.227 401.556C237.243 397.416 245.509 386.891 248.526 386.891C251.542 386.891 258.622 389.516 262.067 390.273C265.512 391.031 267.708 392.154 268.074 397.845C268.44 403.537 263.569 403.865 263.569 403.865L261.688 401.606C261.688 401.606 248.147 421.924 244.02 424.549C241.555 426.136 238.901 427.408 236.12 428.335L218.061 495.676L196.19 476.418Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.485 308.42C274.485 308.42 279.748 312.812 276.24 327.704C272.731 342.595 271.86 350.054 271.86 358.824C271.86 367.595 269.235 379.862 261.764 387.75C254.293 395.637 245.119 407.033 234.164 406.591C216.812 405.897 208.306 382.045 202.614 371.091C196.923 360.137 195.61 345.233 195.61 339.099C195.61 332.966 196.481 318.504 204.369 307.549C212.256 296.595 233.735 292.216 242.935 293.529C252.135 294.841 263.531 296.154 274.485 308.42Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.547 347.87C199.547 347.87 201.301 341.737 209.189 338.229C217.076 334.72 221.897 328.587 219.285 322.883C216.673 317.178 218.023 311.525 229.381 308.42C240.739 305.316 243.843 316.749 254.798 314.995C265.752 313.241 268.818 308.862 274.51 311.487C280.202 314.112 277.577 321.583 277.577 321.583C277.577 321.583 284.593 308.874 271.014 294.412C257.435 279.949 224.56 274.687 201.768 291.345C178.977 308.004 192.127 347 192.127 347C192.127 347 193.414 348.741 199.547 347.87Z",
    fill: "#181616",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.331 355.316L253.018 380.733L243.806 377.224",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.352 389.958C247.352 389.958 238.594 391.22 234.644 385.137",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.647 355.051C237.243 357.575 235.842 359.418 234.53 359.203C233.217 358.989 232.486 356.78 232.889 354.269C233.293 351.757 234.694 349.902 236.006 350.117C237.319 350.331 238.051 352.54 237.647 355.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.727 355.758C265.323 358.282 263.922 360.124 262.61 359.91C261.297 359.695 260.553 357.487 260.969 354.988C261.386 352.489 262.774 350.609 264.086 350.823C265.399 351.038 266.131 353.246 265.727 355.758Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.453 343.605C226.453 343.605 235.88 335.389 243.477 341.775",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.594 341.775C259.594 341.775 265.979 336.31 271.457 341.472",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.561 349.082C249.561 349.082 236.184 346.949 215.487 350.344C215.487 350.344 213.67 364.327 223.4 370.41C233.13 376.492 242.557 370.713 244.98 367.368C249.876 360.705 249.561 349.082 249.561 349.082Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.265 347.164C280.265 347.164 270.699 345.132 255.909 348.325C255.909 348.325 254.647 361.702 261.562 367.507C268.478 373.312 275.268 367.797 277.009 364.604C280.442 358.282 280.265 347.164 280.265 347.164Z",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.561 349.082C249.561 349.082 250.999 345.144 255.871 348.325",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.131 342.078L215.5 350.293",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.302 350.054C201.302 350.054 198.235 332.095 189.944 340.854C181.653 349.612 189.073 358.383 193.011 362.308C196.948 366.232 201.845 362.308 201.845 362.308",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.302 350.054C201.302 350.054 198.235 332.095 189.944 340.854C181.653 349.612 189.073 358.383 193.011 362.308C196.948 366.232 201.845 362.308 201.845 362.308",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.464 438.595C173.864 448.614 177.518 459.48 179.267 470.726C181.905 488.785 181.526 492.18 181.526 492.18L194.689 476.392C194.689 476.392 216.143 491.435 219.512 496.319C222.882 501.203 223.298 502.718 223.298 502.718C223.298 502.718 223.298 532.059 210.88 549.74C198.462 567.42 192.442 567.408 180.415 567.408C168.388 567.408 152.954 556.113 144.676 537.309C136.397 518.505 129.62 491.082 128.118 488.394C126.616 485.706 121.72 470.726 121.72 470.726",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.464 438.595C173.864 448.614 177.518 459.48 179.267 470.726C181.905 488.785 181.526 492.18 181.526 492.18L194.689 476.392C194.689 476.392 216.143 491.435 219.512 496.319C222.882 501.203 223.298 502.718 223.298 502.718C223.298 502.718 223.298 532.059 210.88 549.74C198.462 567.42 192.442 567.408 180.415 567.408C168.388 567.408 152.954 556.113 144.676 537.309C136.397 518.505 129.62 491.082 128.118 488.394C126.616 485.706 121.72 470.726 121.72 470.726",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53 514.252C162.155 515.868 161.006 517.218 160.085 518.165",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.526 492.18C181.526 492.18 174.497 501.014 168.187 508.649",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.407 490.325C191.588 492.686 199.428 496.101 206.729 500.484C219.513 508.056 220.611 516.284 224.397 513.281C228.183 510.277 231.161 500.863 227.4 495.613C223.639 490.363 211.979 477.945 203.712 474.159C195.446 470.373 192.052 472.644 189.414 478.298C186.776 483.952 180.769 486.943 183.407 490.325Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.99 521.118C183.089 524.7 183.632 528.257 184.606 531.706",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.407 490.325C183.407 490.325 182.511 502.945 182.7 514.694",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19 496.723C196.19 496.723 198.828 511.4 201.844 517.786",
    stroke: "#5D69A7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.351 533.208C285.351 533.208 272.554 555.785 274.435 558.448C276.315 561.11 318.075 558.448 318.075 558.448L320.321 549.424C320.321 549.424 328.978 552.806 335.755 552.806C342.532 552.806 337.257 550.926 334.998 548.667C332.739 546.408 319.576 538.142 318.441 537.385C317.305 536.628 295.498 530.949 285.351 533.208Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.598 530.608C312.598 530.608 318.643 528.791 320.258 532.627C321.873 536.464 321.066 552.819 320.46 557.009C319.854 561.199 317.04 561.035 315.828 557.009C314.617 552.983 311.79 531.214 311.79 531.214L312.598 530.608Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.901 532.425C299.901 532.425 308.975 526.178 311.6 529.396C314.225 532.614 316.648 558.019 317.443 559.836C318.238 561.653 314.011 563.054 312.395 561.237C310.78 559.419 306.148 550.156 304.747 546.736C303.347 543.316 299.901 532.425 299.901 532.425Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.969 539.278C281.969 539.278 287.017 530.002 291.244 527.39C295.472 524.777 300.078 529.598 302.325 533.233C304.571 536.867 306.351 546.332 307.373 550.964C308.395 555.595 311.159 560.833 309.594 561.439C308.029 562.044 301.732 556.807 299.914 553.993C298.097 551.179 293.667 540.287 293.667 540.287",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.969 539.278C281.969 539.278 287.017 530.002 291.244 527.39C295.472 524.777 300.078 529.598 302.325 533.233C304.571 536.867 306.351 546.332 307.373 550.964C308.395 555.595 311.159 560.833 309.594 561.439C308.029 562.044 301.732 556.807 299.914 553.993C298.097 551.179 293.667 540.287 293.667 540.287",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.26 556.807C290.26 556.807 283.003 549.752 280.58 547.531C278.157 545.31 274.737 544.313 272.327 546.938C269.916 549.563 268.692 552.781 272.327 556.201C275.961 559.621 284.593 564.114 290.26 564.114C295.926 564.114 294.891 561.287 293.478 559.684C292.522 558.602 291.442 557.636 290.26 556.807Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.439 576.747H482.892V569.187H218.439V576.747Z",
    fill: "#B8B8B8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44 576.747H311.272V569.187H218.44V576.747Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.788 569.162H475.496L485.415 454.964C485.551 453.709 485.419 452.439 485.027 451.239C484.635 450.039 483.992 448.937 483.141 448.005C482.29 447.072 481.25 446.332 480.091 445.832C478.931 445.333 477.679 445.086 476.417 445.107H324.409C321.729 445.158 319.16 446.189 317.189 448.005C315.217 449.821 313.978 452.297 313.707 454.964L303.788 569.162Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.082 569.162H478.79L488.709 454.964C488.845 453.709 488.713 452.439 488.321 451.239C487.929 450.039 487.286 448.937 486.435 448.005C485.584 447.072 484.544 446.332 483.385 445.832C482.225 445.333 480.973 445.086 479.711 445.107H327.703C325.023 445.158 322.454 446.189 320.483 448.005C318.511 449.821 317.272 452.297 317.001 454.964L307.082 569.162Z",
    fill: "#B8B8B8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.084 503.538C394.38 500.623 395.734 497.918 397.89 495.935C400.046 493.951 402.854 492.826 405.783 492.773C407.162 492.749 408.53 493.018 409.796 493.564C411.063 494.109 412.199 494.918 413.129 495.936C414.059 496.954 414.761 498.159 415.19 499.469C415.618 500.78 415.763 502.167 415.614 503.538C415.318 506.453 413.964 509.158 411.808 511.141C409.652 513.125 406.844 514.25 403.915 514.303C402.536 514.327 401.168 514.057 399.902 513.512C398.635 512.967 397.499 512.158 396.569 511.14C395.639 510.122 394.937 508.917 394.508 507.606C394.08 506.296 393.935 504.909 394.084 503.538Z",
    fill: "#F47833",
    stroke: "#F47833",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.37 576.747H21.9844",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.032 221.6L311.832 171C308.432 164.2 306.432 156.6 306.432 148.7C306.432 119.2 332.732 95.2 365.232 95.2H469.932C502.432 95.2 528.732 119.2 528.732 148.7C528.732 178.2 502.432 202.2 469.932 202.2H365.332C356.432 202.2 348.132 200.4 340.532 197.2L284.032 221.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.032 222.7C284.132 222.7 284.332 222.7 284.432 222.6L340.432 198.3C348.232 201.5 356.532 203.2 365.232 203.2H469.932C502.932 203.2 529.832 178.7 529.832 148.6C529.832 118.5 502.932 94 469.932 94H365.332C332.332 94 305.432 118.5 305.432 148.6C305.432 156.4 307.232 163.9 310.632 170.9L283.132 221C282.932 221.4 282.932 221.9 283.332 222.3C283.432 222.6 283.732 222.7 284.032 222.7ZM340.532 196.1C340.432 196.1 340.232 196.1 340.132 196.2L286.632 219.4L312.932 171.6C313.132 171.3 313.132 170.9 312.932 170.6C309.432 163.7 307.732 156.4 307.732 148.8C307.732 119.9 333.632 96.4 365.432 96.4H469.932C501.732 96.4 527.632 119.9 527.632 148.8C527.632 177.7 501.732 201.2 469.932 201.2H365.332C356.832 201.2 348.632 199.6 341.032 196.3C340.832 196.1 340.632 196.1 340.532 196.1Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.732 122.5H457.932C458.832 122.5 459.532 121.8 459.532 120.9C459.532 120 458.832 119.3 457.932 119.3H379.732C378.832 119.3 378.132 120 378.132 120.9C378.132 121.8 378.832 122.5 379.732 122.5Z",
    fill: "#E0E8FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.632 145.9H486.132C487.032 145.9 487.732 145.2 487.732 144.3C487.732 143.4 487.032 142.7 486.132 142.7H347.632C346.732 142.7 346.032 143.4 346.032 144.3C345.932 145.2 346.732 145.9 347.632 145.9Z",
    fill: "#E0E8FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.632 169.3H486.132C487.032 169.3 487.732 168.6 487.732 167.7C487.732 166.8 487.032 166.1 486.132 166.1H347.632C346.732 166.1 346.032 166.8 346.032 167.7C345.932 168.6 346.732 169.3 347.632 169.3Z",
    fill: "#E0E8FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8292_16214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 631,
    height: 631,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.1b23933f21919a4ffdd47c6969e087f3.svg";
export { ForwardRef as ReactComponent };